var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3578_15955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint0_linear_3578_15955)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0036 26.9834C23.5394 26.9834 19.2302 26.9834 19.2302 26.9834C18.7728 26.9834 18.3984 27.3577 18.3984 27.8151V34.0579C18.3984 34.5154 18.7728 34.8896 19.2302 34.8896C19.2302 34.8896 23.6296 34.8896 25.1007 34.8896C25.2964 34.8896 25.2964 34.6794 25.2964 34.6794V27.266C25.2963 27.266 25.2963 26.9834 25.0036 26.9834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7682 26.9834C32.7682 26.9834 28.4425 26.9834 27.0007 26.9834C26.6494 26.9834 26.702 27.3492 26.702 27.3492V34.6862C26.702 34.6862 26.6992 34.8894 26.9105 34.8894C28.3749 34.8894 32.7681 34.8894 32.7681 34.8894C33.2256 34.8894 33.5999 34.5152 33.5999 34.0577V27.8151C33.6 27.3577 33.2257 26.9834 32.7682 26.9834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2961 22.0709C25.2961 22.0709 25.2961 21.7891 25.0176 21.7891C23.3499 21.7891 18.2908 21.7891 18.2908 21.7891C17.8333 21.7891 17.459 22.1634 17.459 22.6208V25.2171C17.459 25.6745 17.8333 26.0488 18.2908 26.0488C18.2908 26.0488 23.3726 26.0488 25.0404 26.0488C25.2961 26.0488 25.2961 25.827 25.2961 25.827V22.0709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7065 21.7891C33.7065 21.7891 28.6453 21.7891 26.9582 21.7891C26.7012 21.7891 26.7012 22.0339 26.7012 22.0339V25.8322C26.7012 25.8322 26.7012 26.0488 27.0136 26.0488C28.6868 26.0488 33.7065 26.0488 33.7065 26.0488C34.1639 26.0488 34.5382 25.6745 34.5382 25.2171V22.6208C34.5382 22.1634 34.1639 21.7891 33.7065 21.7891Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4672 21.1738C22.0866 21.1738 21.739 21.1436 21.4342 21.0841C20.66 20.9328 20.1279 20.6384 19.8075 20.1842C19.5204 19.7771 19.4325 19.2752 19.5462 18.6924C19.7455 17.6728 20.4302 17.1113 21.4742 17.1113C21.6952 17.1113 21.9378 17.1368 22.1954 17.1872C22.8509 17.3152 23.6892 17.6911 24.438 18.1925C25.7084 19.0434 25.7713 19.5723 25.708 19.8962C25.615 20.3722 25.1701 20.7122 24.348 20.936C23.7926 21.0871 23.107 21.1738 22.4672 21.1738ZM21.4743 18.4444C21.07 18.4444 20.931 18.5574 20.8547 18.9481C20.7923 19.2675 20.871 19.379 20.8968 19.4157C21.0049 19.569 21.2865 19.6969 21.6898 19.7756C21.9074 19.8181 22.1763 19.8406 22.4671 19.8406C23.1066 19.8406 23.67 19.7437 24.0438 19.6377C24.071 19.63 24.1133 19.5978 24.068 19.5709C23.5793 19.1727 22.6851 18.6411 21.9398 18.4955C21.7662 18.4617 21.6095 18.4444 21.4743 18.4444Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5502 21.1738C29.5502 21.1738 29.5502 21.1738 29.55 21.1738C28.9102 21.1738 28.2247 21.087 27.6693 20.9359C26.8471 20.7122 26.4023 20.3721 26.3093 19.8962C26.2461 19.5723 26.3088 19.0434 27.5793 18.1925C28.328 17.6911 29.1663 17.3152 29.8219 17.1872C30.0795 17.1368 30.3222 17.1113 30.5429 17.1113C31.5872 17.1113 32.2719 17.6729 32.4709 18.6925C32.5848 19.2752 32.497 19.7771 32.2098 20.1842C31.8894 20.6385 31.3573 20.9328 30.5829 21.0841C30.2782 21.1435 29.9307 21.1738 29.5502 21.1738ZM27.9599 19.5626C27.9166 19.5877 27.9376 19.6274 27.9601 19.6339C28.3337 19.7413 28.903 19.8406 29.55 19.8406C29.841 19.8406 30.1097 19.8181 30.3274 19.7756C30.7306 19.6968 31.0123 19.569 31.1204 19.4157C31.1463 19.379 31.2251 19.2675 31.1625 18.9481C31.0863 18.5574 30.9472 18.4444 30.5429 18.4444C30.4077 18.4444 30.2511 18.4616 30.0774 18.4956C29.332 18.6411 28.4487 19.1644 27.9599 19.5626Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3578_15955",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.429333 0 0 0 0 0.108333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3578_15955"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3578_15955",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3578_15955",
    x1: 28.6531,
    y1: 41.6814,
    x2: 28.3401,
    y2: 8.82096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.a129a2d0b9b6557551e08ad71f4f0321.svg";
export { ForwardRef as ReactComponent };